import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const customIcons = {
  'solid-book-open-magnifying-glass': [
    640,
    512,
    [],
    'e000',
    'M0 83.8C0 71.7 6.8 60.5 18.1 56.1C46.3 45.3 93.5 32 144 32c58.4 0 103.4 20 123 35.6c3.4 2.6 5 6.8 5 11L272 456c0 11.4-11.6 19.3-22.4 15.5C223 462 177.9 448 144 448c-38.5 0-88.4 12.1-119.9 22.6C12.8 474.3 0 466 0 454.1L0 83.8zm304-5.2c0-4.2 1.7-8.4 5-11C328.6 52 373.6 32 432 32c50.5 0 97.7 13.3 125.9 24.2C569.2 60.5 576 71.7 576 83.8L576 224c-29.2-38.8-75.6-64-128-64c-63.4 0-118.1 36.8-144 90.1l0-171.5zm0 311.3c14 28.7 36.2 52.6 63.7 68.6c-15.6 4.2-30.1 9-41.3 13c-10.7 3.8-22.4-4.1-22.4-15.5l0-66.1zM320 320c0-70.7 57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L520 425.8l-.1 .1C499.4 439.8 474.7 448 448 448c-70.7 0-128-57.3-128-128zm48 0c0 28.6 15.2 55 40 69.3s55.2 14.3 80 0s40-40.7 40-69.3s-15.2-55-40-69.3s-55.2-14.3-80 0s-40 40.7-40 69.3z',
  ],
  'solid-file-lines-pen': [
    576,
    512,
    [],
    'e001',
    'M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 139.7-94.7 94.7c-.6 .6-1.2 1.2-1.8 1.8c-1.7-7-8-12.2-15.5-12.2l-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c1.1 0 2.2-.1 3.2-.3c-1.1 2.7-2 5.6-2.7 8.4l-15.1 60.1c-2.3 9.3-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 64zM96 272c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zM256 0L384 128l-128 0L256 0zm33.5 492.1l15-60.1c1.4-5.7 4.3-10.8 8.4-14.9L442.2 287.9l-.1 0 71 71L383.9 488.1c-4.1 4.1-9.3 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM464.8 265.3l29.4-29.4c15.7-15.6 41-15.6 56.6 0l14.3 14.3c15.6 15.7 15.6 41 0 56.6l-29.4 29.4-70.9-70.9z',
  ],
  'book-alt': [
    50,
    47,
    [],
    'e002',
    'M 25.144 47.112 C 24.444 47.112 23.744 46.949 23.161 46.622 C 18.798 44.242 11.121 41.722 6.314 41.092 L 5.637 40.999 C 2.581 40.625 0.061 37.755 0.061 34.652 L 0.061 6.465 C 0.061 4.622 0.784 2.942 2.114 1.729 C 3.444 0.515 5.171 -0.068 6.991 0.095 C 12.124 0.492 19.871 3.059 24.258 5.812 L 24.818 6.139 C 24.981 6.232 25.331 6.232 25.471 6.162 L 25.844 5.929 C 30.231 3.175 37.978 0.562 43.134 0.119 C 43.181 0.119 43.368 0.119 43.414 0.119 C 45.118 -0.045 46.868 0.562 48.174 1.775 C 49.504 2.989 50.228 4.669 50.228 6.512 L 50.228 34.675 C 50.228 37.802 47.708 40.649 44.628 41.022 L 43.858 41.115 C 39.051 41.745 31.351 44.289 27.081 46.645 C 26.521 46.972 25.844 47.112 25.144 47.112 Z M 6.431 3.572 C 5.684 3.572 5.007 3.829 4.471 4.319 C 3.887 4.855 3.561 5.625 3.561 6.465 L 3.561 34.652 C 3.561 36.029 4.751 37.359 6.081 37.545 L 6.781 37.639 C 12.031 38.339 20.081 40.975 24.748 43.519 C 24.958 43.612 25.261 43.635 25.378 43.589 C 30.044 40.999 38.141 38.339 43.414 37.639 L 44.208 37.545 C 45.538 37.382 46.728 36.029 46.728 34.652 L 46.728 6.489 C 46.728 5.625 46.401 4.879 45.818 4.319 C 45.211 3.782 44.441 3.525 43.577 3.572 C 43.531 3.572 43.344 3.572 43.298 3.572 C 38.841 3.969 31.654 6.372 27.734 8.822 L 27.361 9.079 C 26.078 9.872 24.258 9.872 23.021 9.102 L 22.461 8.775 C 18.471 6.325 11.284 3.945 6.711 3.572 C 6.617 3.572 6.524 3.572 6.431 3.572 Z M 25.144 45.152 C 24.187 45.152 23.394 44.359 23.394 43.402 L 23.394 8.402 C 23.394 7.445 24.187 6.652 25.144 6.652 C 26.101 6.652 26.894 7.445 26.894 8.402 L 26.894 43.402 C 26.894 44.382 26.101 45.152 25.144 45.152 Z M 15.227 17.152 L 9.977 17.152 C 9.021 17.152 8.227 16.359 8.227 15.402 C 8.227 14.445 9.021 13.652 9.977 13.652 L 15.227 13.652 C 16.184 13.652 16.977 14.445 16.977 15.402 C 16.977 16.359 16.184 17.152 15.227 17.152 Z M 16.977 24.152 L 9.977 24.152 C 9.021 24.152 8.227 23.359 8.227 22.402 C 8.227 21.445 9.021 20.652 9.977 20.652 L 16.977 20.652 C 17.934 20.652 18.727 21.445 18.727 22.402 C 18.727 23.359 17.934 24.152 16.977 24.152 Z',
  ],
  digibook: [
    57,
    57,
    [],
    'e003',
    'M36.0938 56.4375H20.3438C6.09 56.4375 0 50.3475 0 36.0938V20.3438C0 6.09 6.09 0 20.3438 0H36.0938C50.3475 0 56.4375 6.09 56.4375 20.3438V36.0938C56.4375 50.3475 50.3475 56.4375 36.0938 56.4375ZM20.3438 3.9375C8.2425 3.9375 3.9375 8.2425 3.9375 20.3438V36.0938C3.9375 48.195 8.2425 52.5 20.3438 52.5H36.0938C48.195 52.5 52.5 48.195 52.5 36.0938V20.3438C52.5 8.2425 48.195 3.9375 36.0938 3.9375H20.3438Z M28.2191 46.4624C27.5891 46.4624 26.9591 46.3049 26.4341 46.0161C23.3891 44.3624 18.0078 42.5773 14.6216 42.1311L14.1228 42.0523C11.5503 41.7373 9.50281 39.4274 9.50281 36.7761V16.5636C9.50281 15.0674 10.1329 13.6236 11.2091 12.6261C12.3116 11.6286 13.7291 11.1299 15.2516 11.2611C19.0841 11.5761 24.6491 13.4137 27.9304 15.4612L28.1928 15.6186L28.2979 15.5399C31.6054 13.4662 37.1703 11.6024 41.0291 11.2611C41.0816 11.2611 41.239 11.2611 41.2915 11.2611C42.6565 11.1299 44.1265 11.6549 45.2027 12.6261C46.3052 13.6236 46.9091 15.0148 46.9091 16.5373V36.7236C46.9091 39.3486 44.8615 41.6586 42.2628 41.9999L41.7116 42.0786C38.3516 42.5249 32.944 44.3099 29.9515 45.9636C29.4527 46.3311 28.8491 46.4624 28.2191 46.4624ZM14.8054 15.2248C14.4379 15.2248 14.1228 15.3561 13.8865 15.5661C13.5978 15.8286 13.4666 16.1961 13.4666 16.5899V36.8023C13.4666 37.4323 14.0441 38.0886 14.6479 38.1674L15.1466 38.2461C18.9791 38.7711 24.8591 40.6873 28.2716 42.5511C31.4479 40.7136 37.3541 38.7449 41.2129 38.2461L41.7903 38.1674C42.394 38.0886 42.9716 37.4323 42.9716 36.8023V16.6161C42.9716 16.1961 42.8141 15.8549 42.5516 15.5924C42.2629 15.3299 41.8953 15.2249 41.4753 15.2511C41.4228 15.2511 41.2654 15.2511 41.2129 15.2511C38.1679 15.5136 33.1541 17.1936 30.4241 18.9261L30.1615 19.0836C29.0065 19.7923 27.3791 19.7924 26.2766 19.1099L25.8828 18.8736C23.1265 17.1411 18.1128 15.4873 14.9366 15.2248C14.8841 15.2248 14.8579 15.2248 14.8054 15.2248Z M28.2188 45.0449C27.1425 45.0449 26.25 44.1524 26.25 43.0762V17.9812C26.25 16.905 27.1425 16.0125 28.2188 16.0125C29.295 16.0125 30.1875 16.905 30.1875 17.9812V43.0762C30.1875 44.1787 29.295 45.0449 28.2188 45.0449Z',
  ],
  'uneven-grid': [
    534,
    512,
    [],
    'e004',
    'M477.7 232.5V87.5c0-32-13.7-44.8-47.6-44.8H343.9c-33.9 0-47.6 12.8-47.6 44.8V232.5c0 32 13.7 44.8 47.6 44.8h86.2c33.9 0 47.6-12.8 47.6-44.8zm-224 46.9V424.5c0 32-13.7 44.8-47.6 44.8H119.9c-33.9 0-47.6-12.8-47.6-44.8V279.5c0-32 13.7-44.8 47.6-44.8h86.2c33.9 0 47.6 12.8 47.6 44.8zm224 145.1V364.8c0-32-13.7-44.8-47.6-44.8H343.9c-33.9 0-47.6 12.8-47.6 44.8v59.7c0 32 13.7 44.8 47.6 44.8h86.2c33.9 0 47.6-12.8 47.6-44.8zm-224-277.3V87.5c0-32-13.7-44.8-47.6-44.8H119.9C86 42.7 72.3 55.5 72.3 87.5v59.7c0 32 13.7 44.8 47.6 44.8h86.2c33.9 0 47.6-12.8 47.6-44.8z',
  ],
  'open-book': [
    534,
    512,
    [],
    'e005',
    'M483 103.5V357.1c0 20.7-16.9 39.7-37.5 42.2l-6.6 .9c-35 4.7-84.3 19.2-123.9 35.8c-13.9 5.8-29.2-4.7-29.2-19.8V119.5c0-7.9 4.5-15.1 11.5-19c39-21.1 98.1-39.9 138.2-43.3h1.3c25.6 0 46.3 20.7 46.3 46.3zm-240.9-3c-39-21.1-98.1-39.9-138.2-43.3h-1.5c-25.6 0-46.3 20.7-46.3 46.3V357.1c0 20.7 16.9 39.7 37.5 42.2l6.6 .9c35 4.7 84.3 19.2 123.9 35.8c13.9 5.8 29.2-4.7 29.2-19.8V119.5c0-8.1-4.3-15.1-11.3-19zM120.3 165.1h48c8.7 0 16 7.3 16 16c0 9-7.3 16-16 16h-48c-8.7 0-16-7-16-16c0-8.7 7.3-16 16-16zm64 96h-64c-8.7 0-16-7-16-16c0-8.7 7.3-16 16-16h64c8.7 0 16 7.3 16 16c0 9-7.3 16-16 16z',
  ],
  'trend-up': [
    534,
    512,
    [],
    'e006',
    'M348.4 42.7H169.6C92 42.7 45.7 89 45.7 166.6V345.2C45.7 423 92 469.3 169.6 469.3H348.2c77.7 0 123.9-46.3 123.9-123.9V166.6C472.3 89 426 42.7 348.4 42.7zM363.1 246c0 8.3-6.6 14.9-14.9 14.9s-14.9-6.6-14.9-14.9v-3.8l-58 58c-3.2 3.2-7.5 4.7-11.9 4.3s-8.5-2.8-10.9-6.6l-21.8-32.4-50.8 50.8c-3 3-6.6 4.3-10.5 4.3s-7.7-1.5-10.5-4.3c-5.8-5.8-5.8-15.1 0-21.1l63.6-63.6c3.2-3.2 7.5-4.7 11.9-4.3s8.5 2.8 10.9 6.6l21.8 32.4 45-45h-3.8c-8.3 0-14.9-6.6-14.9-14.9s6.6-14.9 14.9-14.9H348c1.9 0 3.8 .4 5.8 1.1c3.6 1.5 6.6 4.5 8.1 8.1c.9 1.9 1.1 3.8 1.1 5.8V246h.2z',
  ],
  notes: [
    532,
    512,
    [],
    'e007',
    'M278 425.7c5.9 1.4 6.4 9 .7 10.9L245 447.8c-84.7 27.3-129.3 4.5-156.8-80.2L60.9 283.3c-27.3-84.7-4.7-129.5 80-156.8l12.8-4.3c7.9-2.6 15.6 5.3 13.3 13.4c-1.4 4.8-2.7 9.9-4 15.2l-20.9 89.4C118.7 340.7 153 396.2 253.5 420.1l24.5 5.7zM373.8 68.5l-35.6-8.3c-71.3-16.9-113.7-3-138.7 48.6c-6.4 13-11.5 28.8-15.8 46.9l-20.9 89.4c-20.9 89.2 6.6 133.1 95.6 154.2l35.8 8.5c12.4 3 23.9 4.9 34.6 5.8c66.6 6.4 102-24.7 119.9-101.8l20.9-89.2c20.9-89.2-6.4-133.3-95.8-154.2zM333.7 284.4c-1.9 7.3-8.3 11.9-15.6 11.9c-1.3 0-2.6-.2-4.1-.4L252 280.1c-8.5-2.1-13.7-10.9-11.5-19.4s10.9-13.7 19.4-11.5L322 265c8.7 2.1 13.9 10.9 11.7 19.4zm62.5-72.1c-1.9 7.3-8.3 11.9-15.6 11.9c-1.3 0-2.6-.2-4.1-.4L273.1 197.5c-8.5-2.1-13.7-10.9-11.5-19.4s10.9-13.7 19.4-11.5l103.5 26.2c8.7 1.9 13.9 10.7 11.7 19.4z',
  ],
  'new-stars': [
    17,
    17,
    [],
    'e009',
    'M11.1562 4.78125L10.75 3.25L9.21875 2.84375C9.09375 2.78125 9 2.65625 9 2.5C9 2.375 9.09375 2.25 9.21875 2.1875L10.75 1.75L11.1562 0.25C11.2188 0.125 11.3438 0 11.5 0C11.625 0 11.75 0.125 11.8125 0.25L12.25 1.75L13.75 2.1875C13.875 2.25 14 2.375 14 2.5C14 2.65625 13.875 2.78125 13.75 2.84375L12.25 3.25L11.8125 4.78125C11.75 4.90625 11.625 5 11.5 5C11.3438 5 11.2188 4.90625 11.1562 4.78125ZM7.65625 4.9375L9.09375 7.875L12.3438 8.34375C12.9375 8.4375 13.1875 9.1875 12.75 9.625L10.4062 11.9062L10.9688 15.125C11.0625 15.75 10.4375 16.2188 9.875 15.9375L6.96875 14.4062L4.09375 15.9375C3.53125 16.2188 2.90625 15.75 3 15.125L3.5625 11.9062L1.21875 9.625C0.78125 9.1875 1 8.4375 1.625 8.34375L4.875 7.875L6.3125 4.9375C6.59375 4.375 7.375 4.375 7.65625 4.9375ZM14.375 7.625L13.1875 7.28125C13.0625 7.25 13 7.125 13 7C13 6.90625 13.0625 6.78125 13.1875 6.75L14.375 6.40625L14.7188 5.21875C14.75 5.09375 14.875 5 15 5C15.0938 5 15.2188 5.09375 15.25 5.21875L15.5938 6.40625L16.7812 6.75C16.9062 6.78125 17 6.90625 17 7C17 7.125 16.9062 7.25 16.7812 7.28125L15.5938 7.625L15.25 8.8125C15.2188 8.9375 15.0938 9 15 9C14.875 9 14.75 8.9375 14.7188 8.8125L14.375 7.625Z',
  ],
  'arrow-dash-right': [
    24,
    24,
    [],
    'e00a',
    'M14.1 5.263a.662.662 0 0 0-.345.357.756.756 0 0 0-.013.611c.043.103.81.898 2.488 2.578l2.427 2.429-3.939.011-3.938.011-.169.11c-.456.296-.446.988.019 1.277l.15.093 3.938.011 3.939.011-2.427 2.429c-1.678 1.68-2.445 2.475-2.488 2.578a.752.752 0 0 0 .014.611.665.665 0 0 0 .478.402.714.714 0 0 0 .639-.117c.081-.057 1.519-1.476 3.195-3.154 2.128-2.13 3.067-3.096 3.11-3.2A.972.972 0 0 0 21.24 12a.972.972 0 0 0-.062-.311c-.071-.172-6.039-6.173-6.335-6.371a.583.583 0 0 0-.4-.118.905.905 0 0 0-.343.063M3.42 11.259a1.675 1.675 0 0 1-.149.038.747.747 0 0 0-.256.153c-.42.368-.316.993.205 1.234.148.069.295.074 2.022.075 1.852.001 1.862.001 2.037-.089a1.1 1.1 0 0 0 .299-.244c.109-.137.122-.182.122-.426 0-.245-.012-.288-.124-.426-.265-.327-.163-.313-2.256-.322a64.736 64.736 0 0 0-1.9.007',
  ],
  home: [
    20,
    20,
    [],
    'e0010',
    'M18.04 4.81994L12.28 0.789938C10.71 -0.310062 8.29999 -0.250062 6.78999 0.919938L1.77999 4.82994C0.77999 5.60994 -0.0100098 7.20994 -0.0100098 8.46994V15.3699C-0.0100098 17.9199 2.05999 19.9999 4.60999 19.9999H15.39C17.94 19.9999 20.01 17.9299 20.01 15.3799V8.59994C20.01 7.24994 19.14 5.58994 18.04 4.81994ZM10.75 15.9999C10.75 16.4099 10.41 16.7499 9.99999 16.7499C9.58999 16.7499 9.24999 16.4099 9.24999 15.9999V12.9999C9.24999 12.5899 9.58999 12.2499 9.99999 12.2499C10.41 12.2499 10.75 12.5899 10.75 12.9999V15.9999Z',
  ],
  'pen-line': [
    12,
    12,
    [],
    'e00b',
    'M0.886733 8.82422L1.33595 7.29883C1.41798 7.02344 1.56642 6.77148 1.76955 6.56836L7.709 0.626953C8.19728 0.138672 8.9883 0.138672 9.47658 0.626953L10.2461 1.39648C10.3067 1.45703 10.3613 1.52344 10.4063 1.5918C10.7266 2.07617 10.6738 2.73633 10.2461 3.16406L4.30665 9.10547C4.28126 9.13086 4.25587 9.15625 4.22853 9.17969C4.04103 9.3457 3.81837 9.46875 3.57619 9.53906L2.0508 9.98828L1.22658 10.2305C1.06251 10.2793 0.88478 10.2344 0.763686 10.1113C0.642592 9.98828 0.595717 9.81445 0.644545 9.64844L0.886733 8.82422ZM2.10158 8.01953L1.78517 9.08984L2.85548 8.77539L3.31251 8.64062C3.43751 8.60352 3.55275 8.53516 3.64455 8.44336L8.10548 3.98047L6.89455 2.76953L2.43165 7.23047C2.41994 7.24219 2.40822 7.25391 2.39845 7.26563C2.32228 7.35156 2.26759 7.45312 2.23439 7.5625L2.09962 8.01953H2.10158ZM5.46876 9.3125H11.4063C11.666 9.3125 11.875 9.52148 11.875 9.78125C11.875 10.041 11.666 10.25 11.4063 10.25H5.46876C5.209 10.25 5.00001 10.041 5.00001 9.78125C5.00001 9.52148 5.209 9.3125 5.46876 9.3125Z',
  ],
  eraser: [
    16,
    14,
    [],
    'e00b',
    'M8.0625 0.78125C8.84375 0 10.125 0 10.9062 0.78125L15.1875 5.0625C15.9688 5.84375 15.9688 7.125 15.1875 7.90625L11.0938 11.9688H15C15.5312 11.9688 16 12.4375 16 12.9688C16 13.5312 15.5312 13.9688 15 13.9688H8.28125H8H4.6875C4.15625 13.9688 3.65625 13.7812 3.28125 13.4062L0.78125 10.9062C0 10.125 0 8.84375 0.78125 8.0625L8.0625 0.78125ZM8.28125 11.9688L10.375 9.875L6.09375 5.59375L2.1875 9.46875L4.6875 11.9688H8H8.28125Z',
  ],
  toggle: [
    18,
    16,
    [],
    'e00b',
    'M12 4H6C3.78125 4 2 5.8125 2 8C2 10.2188 3.78125 12 6 12H12C14.1875 12 16 10.2188 16 8C16 5.8125 14.1875 4 12 4ZM18 8C18 11.3125 15.3125 14 12 14H6C2.6875 14 0 11.3125 0 8C0 4.6875 2.6875 2 6 2H12C15.3125 2 18 4.6875 18 8ZM6 11C4.90625 11 3.9375 10.4375 3.375 9.5C2.84375 8.59375 2.84375 7.4375 3.375 6.5C3.9375 5.59375 4.90625 5 6 5C7.0625 5 8.03125 5.59375 8.59375 6.5C9.125 7.4375 9.125 8.59375 8.59375 9.5C8.03125 10.4375 7.0625 11 6 11Z',
  ],
};

const fakSolidBookOpenMagnifyingGlass = {
  icon: customIcons['solid-book-open-magnifying-glass'],
  iconName: 'solid-book-open-magnifying-glass',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakSolidFileLinesPen = {
  icon: customIcons['solid-file-lines-pen'],
  iconName: 'solid-file-lines-pen',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakBookAlt = {
  icon: customIcons['book-alt'],
  iconName: 'book-alt',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakDigibook = {
  icon: customIcons['digibook'],
  iconName: 'digibook',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakUnevenGrid = {
  icon: customIcons['uneven-grid'],
  iconName: 'uneven-grid',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakOpenBook = {
  icon: customIcons['open-book'],
  iconName: 'open-book',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakHome = {
  icon: customIcons['home'],
  iconName: 'home',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakTrendUp = {
  icon: customIcons['trend-up'],
  iconName: 'trend-up',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakNotes = {
  icon: customIcons['notes'],
  iconName: 'notes',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakNewStars = {
  icon: customIcons['new-stars'],
  iconName: 'new-stars',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakArrowDashRight = {
  icon: customIcons['arrow-dash-right'],
  iconName: 'arrow-dash-right',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakPenLine = {
  icon: customIcons['pen-line'],
  iconName: 'pen-line',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakEraser = {
  icon: customIcons['eraser'],
  iconName: 'eraser',
  prefix: 'fak',
} as unknown as IconDefinition;

const fakToggle = {
  icon: customIcons['toggle'],
  iconName: 'toggle',
  prefix: 'fak',
} as unknown as IconDefinition;

export const custom = {
  fakSolidBookOpenMagnifyingGlass,
  fakSolidFileLinesPen,
  fakBookAlt,
  fakDigibook,
  fakUnevenGrid,
  fakOpenBook,
  fakTrendUp,
  fakNotes,
  fakArrowDashRight,
  fakNewStars,
  fakHome,
  fakPenLine,
  fakEraser,
  fakToggle,
};
